"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.Form = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const core_1 = require("@material-ui/core");
exports.Form = styled_components_1.default.form `
  margin: 0 auto;
  box-sizing: border-box;
`;
exports.Input = (0, styled_components_1.default)(core_1.TextField).attrs(({ type }) => ({
    fullWidth: true,
    variant: 'outlined',
    margin: 'normal',
    required: true,
    type: type || 'text',
})) ``;
